import { styled } from '@mui/material/styles';
import { Link, useLocation } from 'react-router-dom';
// import loadingImage from 'assets/img/loading.png';
import errorImage from 'assets/img/whoops.png';
import { Button, Fade, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ExtendedError, ValidationError } from 'shared/services/abstractApiService';

export const StateLoading = () => {
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoader(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);
  if (showLoader) {
    return (
      <Fade appear in>
        <StyledWrapperBox>
          <StyledErrorBox>
            <Typography variant="h2">Aan het laden...</Typography>
            {/* <img src={loadingImage} alt="Loading" className={styles.image} /> */}
          </StyledErrorBox>
        </StyledWrapperBox>
      </Fade>
    );
  }

  return null;
};

interface ErrorProps {
  error: unknown;
  hideNavigation?: boolean;
}

export const StateError = ({ error, hideNavigation = false }: ErrorProps) => {
  const location = useLocation();
  const paths = ['/ogp', '/hq', '/partner'];

  const url = paths.find((path) => location.pathname.startsWith(path)) || '';

  if (!url) {
    // eslint-disable-next-line no-console
    console.error('Unknown location pathname', location.pathname);
  }

  function errorHeading() {
    if (error instanceof ExtendedError) {
      return <StyledErrorHeading variant="h2">{error.title}</StyledErrorHeading>;
      // Checking for the rest of the errors that are not ExtendedErrors (Ex ValidationErrors)
    } else if (error instanceof Error) {
      return <StyledErrorHeading variant="h2">Oeps, er ging iets mis.</StyledErrorHeading>;
    }
  }

  function errorMessage() {
    if (error instanceof ValidationError) {
      return error.errors.message.map((individualError) => (
        <Typography key={individualError.msg} variant="body1">
          {individualError.msg}
        </Typography>
      ));
    } else if (error instanceof Error) {
      return <Typography variant="body1">{error.message}</Typography>;
    }
  }

  return (
    <StyledWrapperBox>
      <StyledErrorBox>
        {errorHeading()}
        {errorMessage()}
        <StyledImage src={errorImage} alt="Error" />
        {!hideNavigation ? (
          <Link to={url} onClick={() => (window.location.href = url)}>
            <StyledButton variant="text" color="primary">
              <Typography variant="h3">Terug naar home</Typography>
            </StyledButton>
          </Link>
        ) : null}
      </StyledErrorBox>
    </StyledWrapperBox>
  );
};

const StyledWrapperBox = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledImage = styled('img')(({ theme }) => ({
  margin: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(2),
}));

const StyledErrorBox = styled('div')(({ theme }) => ({
  postion: 'relative',
  width: '25vw',
  maxWidth: '450px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  alignSelf: 'center',
  textAlign: 'center',
  padding: theme.spacing(2),
}));

const StyledErrorHeading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
